import React from 'react';
import Navigation from '../components/layout/Navigation';
import BibliotecaHero from '../components/layout/BibliotecaHero';
import CoursesSection from '../components/layout/CoursesSection';
import EmBreveSection from '../components/layout/EmBreveSection';
import QuemEManuelaSection from '../components/layout/QuemEManuelaSection';
import OQueEOClubeSection from '../components/layout/OQueEOClubeSection';
import DuvidasSection from '../components/layout/DuvidasSection';

export default function BibliotecaLandingPage() {
  return (
    <>
      <Navigation />
      <BibliotecaHero />
      <OQueEOClubeSection />
      <CoursesSection />
      <EmBreveSection />
      <DuvidasSection />
      <QuemEManuelaSection altBackground/>
    </>
  );
}
